import {all, fork, put, takeLatest, select, call} from 'redux-saga/effects'
import types from 'actions/types'
import {generalError} from 'actions/index'
import {getSystemName} from 'selectors/data'
import {getAccountId} from 'selectors/auth'
import {deobserve, observe} from 'actions/socket'
import {DataType} from 'helpers/socket'

export default () => {

  function * observeData(dataType, objectId)  {
    try {
      const systemName = yield select(getSystemName)
      const accountId = yield select(getAccountId)
      yield put(observe(systemName, accountId, dataType, objectId))
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function * deobserveData(dataType, objectId)  {
    try {
      const systemName = yield select(getSystemName)
      const accountId = yield select(getAccountId)
      yield put(deobserve(systemName, accountId, dataType, objectId))
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function* observeQuote({ref}) {
    yield call(observeData, DataType.ORDER, ref)
  }

  function* deobserveQuote({ref}) {
    yield call(deobserveData, DataType.ORDER, ref)
  }

  function* observeContact({id}) {
    yield call(observeData, DataType.CONTACT, id)
  }

  function* deobserveContact({id}) {
    yield call(deobserveData, DataType.CONTACT, id)
  }

  function* observeCompany({id}) {
    yield call(observeData, DataType.COMPANY, id)
  }

  function* deobserveCompany({id}) {
    yield call(deobserveData, DataType.COMPANY, id)
  }

  function* observeInvoice({id}) {
    yield call(observeData, DataType.INVOICE, id)
  }

  function* deobserveInvoice({id}) {
    yield call(deobserveData, DataType.INVOICE, id)
  }

  function* observePart({id}) {
    yield call(observeData, DataType.PART, id)
  }

  function* deObservePart({id}) {
    yield call(deobserveData, DataType.PART, id)
  }

  function* observePurchaseOrder({id}) {
    yield call(observeData, DataType.PURCHASE_ORDER, id)
  }

  function* deObservePurchaseOrder({id}) {
    yield call(deobserveData, DataType.PURCHASE_ORDER, id)
  }

  function* observePurchaseInvoice({id}) {
    yield call(observeData, DataType.PURCHASE_INVOICE, id)
  }

  function* deObservePurchaseInvoice({id}) {
    yield call(deobserveData, DataType.PURCHASE_INVOICE, id)
  }

  function* observeJobCards() {
    yield call(observeData, DataType.JOB_CARD, null)
  }

  function* deObserveJobCards() {
    yield call(deobserveData, DataType.JOB_CARD, null)
  }

  function* observeOpportunities() {
    yield call(observeData, DataType.OPPORTUNITY, null)
  }

  function* deObserveOpportunities() {
    yield call(deobserveData, DataType.OPPORTUNITY, null)
  }

  function* observeCompanies() {
    yield call(observeData, DataType.COMPANY, null)
  }

  function* deObserveCompanies() {
    yield call(deobserveData, DataType.COMPANY, null)
  }

  function* observeContacts() {
    yield call(observeData, DataType.CONTACT, null)
  }

  function* deObserveContacts() {
    yield call(deobserveData, DataType.CONTACT, null)
  }

  function* observeDeliveries() {
    yield call(observeData, DataType.DELIVERY, null)
  }

  function* deObserveDeliveries() {
    yield call(deobserveData, DataType.DELIVERY, null)
  }

  function* myWatcher() {
    yield all([
      takeLatest(types.OBSERVE_QUOTE, observeQuote),
      takeLatest(types.DEOBSERVE_QUOTE, deobserveQuote),
      takeLatest(types.OBSERVE_CONTACT, observeContact),
      takeLatest(types.DEOBSERVE_CONTACT, deobserveContact),
      takeLatest(types.OBSERVE_COMPANY, observeCompany),
      takeLatest(types.DEOBSERVE_COMPANY, deobserveCompany),
      takeLatest(types.OBSERVE_INVOICE, observeInvoice),
      takeLatest(types.DEOBSERVE_INVOICE, deobserveInvoice),
      takeLatest(types.OBSERVE_PART, observePart),
      takeLatest(types.DEOBSERVE_PART, deObservePart),
      takeLatest(types.OBSERVE_PURCHASE_ORDER, observePurchaseOrder),
      takeLatest(types.DEOBSERVE_PURCHASE_ORDER, deObservePurchaseOrder),
      takeLatest(types.OBSERVE_PURCHASE_INVOICE, observePurchaseInvoice),
      takeLatest(types.DEOBSERVE_PURCHASE_INVOICE, deObservePurchaseInvoice),
      takeLatest(types.OBSERVE_JOB_CARDS, observeJobCards),
      takeLatest(types.DEOBSERVE_JOB_CARDS, deObserveJobCards),
      takeLatest(types.OBSERVE_OPPORTUNITIES, observeOpportunities),
      takeLatest(types.DEOBSERVE_OPPORTUNITIES, deObserveOpportunities),
      takeLatest(types.OBSERVE_COMPANIES, observeCompanies),
      takeLatest(types.DEOBSERVE_COMPANIES, deObserveCompanies),
      takeLatest(types.OBSERVE_CONTACTS, observeContacts),
      takeLatest(types.DEOBSERVE_CONTACTS, deObserveContacts),
      takeLatest(types.OBSERVE_DELIVERY, observeDeliveries),
      takeLatest(types.DEOBSERVE_DELIVERY, deObserveDeliveries),
    ])
  }

  function* watcher() {
    yield fork(myWatcher)
  }

  return {
    watcher,
  }
}
